import { BluetoothApp } from "./app";

(window as any).app = new BluetoothApp()
